<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Monitor from "@/services/monitor";
import {required, url, numeric, decimal} from "vuelidate/lib/validators";

export default {
  page: {
    title: "WWWroot",
    meta: [{name: "description", content: appConfig.description}]
  },
  components: {Layout, PageHeader},
  data() {
    return {
      title: "WWWroot",
      items: [
        {
          text: "Monitor",
          href: "/"
        },
        {
          text: "Monitor List",
          active: true
        }
      ],
      restful: {
        monitors: null,
        metrics: null,
        monitor: {
          id: '',
          url: '',
          alias: '',
          period: 60,
          apdex_t: 0.75,
          is_enabled: true,
          skip_verify: false,
        },
      },
      state: {
        monitor: null,
        monitor_modal: false,
        metrics_url_parameters: [
          {key: "15M", value: {interval: 1, limit: 15}},
          {key: "1H", value: {interval: 5, limit: 12}},
          {key: "1D", value: {interval: 60, limit: 24}},
          {key: "1W", value: {interval: 1440, limit: 7}},
          {key: "1M", value: {interval: 1440, limit: 31}}
        ],
        fields: [
          'id',
          'url',
          'alias',
          'period',
          'apdex_t',
          'is_enabled',
          'skip_verify'
        ],
        submitted: false,
      }
    };
  },
  validations: {
    restful: {
      monitor: {
        url: {required, url},
        alias: {required},
        period: {required, numeric},
        apdex_t: {required, decimal},
        is_enabled: {required},
        skip_verify: {required},
      }
    }
  },
  computed: {
    satisfied: function () {
      if (this.restful.metrics == null) {
        return 0;
      }

      return this.restful.metrics.reduce(function (satisfied, metric) {
        return satisfied + metric.apdex.satisfied
      }, 0)
    },
    tolerated: function () {
      if (this.restful.metrics == null) {
        return 0;
      }

      return this.restful.metrics.reduce(function (satisfied, metric) {
        return satisfied + metric.apdex.tolerated
      }, 0)
    },
    frustrated: function () {
      if (this.restful.metrics == null) {
        return 0;
      }

      return this.restful.metrics.reduce(function (satisfied, metric) {
        return satisfied + metric.apdex.frustrated
      }, 0)
    },
    score: function () {
      if (this.restful.metrics == null) {
        return 0;
      }

      return this.restful.metrics.reduce(function (score, metric) {
        return score + metric.apdex.score
      }, 0) / this.restful.metrics.length
    },
    series: function () {
      if (this.restful.metrics == null) {
        return [];
      }

      return [{
        type: 'area',
        name: 'name lookup',
        data: this.restful.metrics.map(metrics => (metrics.timeline.name_lookup)).reverse()
      }, {
        type: 'area',
        name: 'connect',
        data: this.restful.metrics.map(metrics => (metrics.timeline.connect)).reverse()
      }, {
        type: 'area',
        name: 'app connect',
        data: this.restful.metrics.map(metrics => (metrics.timeline.app_connect)).reverse()
      }, {
        type: 'area',
        name: 'pre transfer',
        data: this.restful.metrics.map(metrics => (metrics.timeline.pre_transfer)).reverse()
      }, {
        type: 'area',
        name: 'start transfer',
        data: this.restful.metrics.map(metrics => (metrics.timeline.start_transfer)).reverse()
      }, {
        type: 'area',
        name: 'total',
        data: this.restful.metrics.map(metrics => (metrics.timeline.total)).reverse()
      }]
    },
    apex: function () {
      return {
        chart: {
          type: 'area',
          height: 240,
          stacked: false,
          toolbar: {
            show: false,
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth',
        },
        fill: {
          type: 'solid',
          opacity: [0.1, 0.1, 0.1, 0.1, 0.1, 0.1],
        },
        yaxis: {
          labels: {
            formatter: function (value) {
              return Math.round(value)
            }
          }
        },
        xaxis: {
          categories: this.restful.metrics.map(metrics => (this.$moment(metrics.created_at).format("dd HH:mm"))).reverse()
        },
        colors: [
          '#f46a6a', '#74788d',
          '#495057', '#556ee6',
          '#f1b44c', '#34c38f',
        ],
      };
    },
  },
  mounted() {
    this.retrieveMonitors()
  },
  methods: {
    ...Monitor,
    retrieveMonitors: function () {
      this.retrieve().then(
          response => {
            this.restful.monitors = response.data.payload
          }
      )
    },
    retrieveMonitorMetrics: function (monitor, url_parameters) {
      this.metrics(monitor, url_parameters).then(
          response => {
            this.state.monitor = monitor
            this.restful.metrics = response.data.payload
          }
      )
    },
    saveMonitor: function (evt) {
      // prevent modal from closing
      evt.preventDefault()

      this.state.submitted = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        return
      }

      // data sanitization
      for (let property in this.restful.monitor) {
        if (this.restful.monitor.hasOwnProperty(property)) {
          // unset filter if any or empty
          if (this.state.fields.indexOf(property) === -1) {
            delete this.restful.monitor[property]
          }
        }
      }

      // save monitor information
      this.save(this.restful.monitor).then(
          response => {
            this.restful.monitor = response.data.payload

            if (response.method === 'post') {
              this.restful.monitors.push(this.restful.monitor)
            } else {
              let index = this.lodash.findIndex(this.restful.monitors, {id: this.restful.monitor.id})
              this.restful.monitors.splice(index, 1, this.restful.monitor)
            }

            this.showMonitorModal()
            this.resetMonitorInformation()
          }
      )
    },
    showMonitorModal(monitor) {
      // clear monitor information
      if (this.state.monitor_modal === false) {
        this.state.submitted = false
        this.resetMonitorInformation()
      }

      // make sure the monitor object is actually an monitor
      if (monitor.hasOwnProperty('id') === true) {
        this.restful.monitor = monitor
      }

      // show upload modal
      this.state.monitor_modal = !this.state.monitor_modal
    },
    resetMonitorInformation() {
      this.restful.monitor = {
        id: '',
        url: '',
        alias: '',
        period: 60,
        apdex_t: 0.75,
        is_enabled: true,
        skip_verify: false,
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-xl-5">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">
              <h4 class="card-title mb-4">Monitors</h4>
              <b-button class="btn btn-success ms-auto" @click="showMonitorModal">Add Monitor</b-button>
            </div>
            <b-modal title="Add Monitor" v-model="state.monitor_modal" hide-footer>
              <b-alert :show="state.submitted === true" dismissible @dismissed="state.submitted=false"
                       variant="success">
                <i class="mdi mdi-check-all me-2"></i>Monitor created!
              </b-alert>

              <form @submit.prevent="saveMonitor">
                <div class="row">
                  <div class="col-12">
                    <div class="mb-3">
                      <b-form-group class="mb-3" id="input-group-1" label="URL" label-for="url">
                        <b-form-input
                            id="url"
                            v-model="restful.monitor.url"
                            type="text"
                            placeholder="Enter URL"
                            :class="{ 'is-invalid': state.submitted && $v.restful.monitor.url.$error }"
                        ></b-form-input>
                        <div v-if="state.submitted && $v.restful.monitor.url.$error" class="invalid-feedback">
                          <span v-if="!$v.restful.monitor.url.required">URL is required.</span>
                        </div>
                      </b-form-group>

                      <b-form-group class="mb-3" id="input-group-1" label="Alias" label-for="alias">
                        <b-form-input
                            id="alias"
                            v-model="restful.monitor.alias"
                            type="text"
                            placeholder="Enter Alias"
                            :class="{ 'is-invalid': state.submitted && $v.restful.monitor.alias.$error }"
                        ></b-form-input>
                        <div v-if="state.submitted && $v.restful.monitor.alias.$error" class="invalid-feedback">
                          <span v-if="!$v.restful.monitor.alias.required">Alias is required.</span>
                        </div>
                      </b-form-group>

                      <b-form-group class="mb-3" id="input-group-1" label="Period" label-for="period">
                        <b-form-input
                            id="period"
                            v-model="restful.monitor.period"
                            type="number"
                            :number="true"
                            placeholder="Enter Period"
                            :class="{ 'is-invalid': state.submitted && $v.restful.monitor.period.$error }"
                        ></b-form-input>
                        <div v-if="state.submitted && $v.restful.monitor.period.$error" class="invalid-feedback">
                          <span v-if="!$v.restful.monitor.period.required">Period is required.</span>
                        </div>
                      </b-form-group>

                      <b-form-group class="mb-3" id="input-group-1" label="Apdex T" label-for="apdex_t">
                        <b-form-input
                            id="apdex_t"
                            v-model="restful.monitor.apdex_t"
                            type="number"
                            step="0.01"
                            :number="true"
                            placeholder="Enter Apdex T"
                            :class="{ 'is-invalid': state.submitted && $v.restful.monitor.apdex_t.$error }"
                        ></b-form-input>
                        <div v-if="state.submitted && $v.restful.monitor.apdex_t.$error" class="invalid-feedback">
                          <span v-if="!$v.restful.monitor.apdex_t.required">Apdex T is required.</span>
                        </div>
                      </b-form-group>
                    </div>
                  </div>
                </div>
                <div class="text-end mt-3">
                  <b-button variant="light" @click="state.monitor_modal = !state.monitor_modal">Close</b-button>
                  <b-button type="submit" variant="success" class="ms-1">Save</b-button>
                </div>
              </form>
            </b-modal>
            <div class="table-responsive mb-0" v-if="restful.monitors != null"> <!-- style="max-height: 465px" -->
              <table class="table table-nowrap table-centered align-middle">
                <thead>
                <tr>
                  <th scope="col">Alias</th>
                  <th scope="col">Status</th>
                  <th scope="col">Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="monitor in restful.monitors" v-bind:key="monitor.id"
                    :class="{'table-light' : monitor === state.monitor}">
                  <td>
                    <h5 class="text-truncate font-size-14 m-0">
                      <a href="#" class="text-dark"
                         v-on:click="retrieveMonitorMetrics(monitor, state.metrics_url_parameters.find(obj => {return obj.key === '1D'}).value)">
                        {{ monitor.alias }}
                      </a>
                    </h5>
                  </td>
                  <td>
                    <span class="badge bg-success" v-if="monitor.is_enabled === true">Enabled</span>
                    <span class="badge bg-danger" v-else>Disabled</span>
                  </td>
                  <td>
                    <b-dropdown class="card-drop" variant="white" menu-class="dropdown-menu-end" right
                                toggle-class="p-0">
                      <template v-slot:button-content>
                        <i class="mdi mdi-dots-horizontal font-size-18"></i>
                      </template>

                      <b-dropdown-item v-if="monitor.is_enabled === true">
                        <i class="fas fa-pause text-info mr-1"></i> Pause
                      </b-dropdown-item>

                      <b-dropdown-item v-else>
                        <i class="fas fa-play text-success mr-1"></i> Start
                      </b-dropdown-item>

                      <b-dropdown-item @click="showMonitorModal(monitor)">
                        <i class="fas fa-pencil-alt text-warning mr-1"></i> Edit
                      </b-dropdown-item>

                      <b-dropdown-item>
                        <i class="fas fa-trash-alt text-danger mr-1"></i> Delete
                      </b-dropdown-item>
                    </b-dropdown>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-7" v-if="restful.metrics != null">
        <div class="row">
          <div class="col-lg-12">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-lg-6">
                    <div class="media">
                      <div class="media-body align-self-center">
                        <h4 class="mb-1"> {{ state.monitor.alias }} </h4>
                        <p class="mb-0">
                        <span class="badge rounded-pill bg-info"
                              v-if="state.monitor.http_request === undefined">HEAD</span>
                          <span class="badge rounded-pill bg-success"
                                v-else-if="state.monitor.http_request.method === 'get'">GET</span>
                          <span class="badge rounded-pill bg-secondary"
                                v-else-if="state.monitor.http_request.method === 'head'">HEAD</span>
                          <span class="badge rounded-pill bg-secondary"
                                v-else-if="state.monitor.http_request.method === 'options'">OPTIONS</span>
                          <span class="badge rounded-pill bg-danger"
                                v-else-if="state.monitor.http_request.method === 'delete'">DELETE</span>
                          <span class="badge rounded-pill bg-warning"
                                v-else-if="state.monitor.http_request.method === 'patch'">PATCH</span>
                          <span class="badge rounded-pill bg-warning"
                                v-else-if="state.monitor.http_request.method === 'put'">PUT</span>
                          <span class="badge rounded-pill bg-info"
                                v-else-if="state.monitor.http_request.method === 'post'">POST</span>
                          {{ state.monitor.url }}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="col-lg-6 align-self-center">
                    <div class="text-lg-center mt-4 mt-lg-0">
                      <div class="row">
                        <div class="col-4">
                          <div>
                            <p class="text-muted text-truncate mb-2">Interval</p>
                            <h5 class="mb-0">{{
                                moment("2015-01-01")
                                    .startOf('day')
                                    .seconds(state.monitor.period)
                                    .format('mm:ss')
                              }}</h5>
                          </div>
                        </div>
                        <div class="col-4">
                          <div>
                            <p class="text-muted text-truncate mb-2">Apdex T</p>
                            <h5 class="mb-0">{{ state.monitor.apdex_t }}</h5>
                          </div>
                        </div>
                        <div class="col-4">
                          <div>
                            <p class="text-muted text-truncate mb-2">Skip Verify</p>
                            <h5 class="mb-0">{{ state.monitor.skip_verify === true ? 'Yes' : 'No' }}</h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-3">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="media">
                  <div class="me-3 align-self-center">
                    <i class="bx bx-happy-beaming h2 text-success mb-0"></i>
                  </div>
                  <div class="media-body">
                    <p class="text-muted mb-2">Satisfied</p>
                    <h5 class="mb-0">
                      {{ satisfied }}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="media">
                  <div class="me-3 align-self-center">
                    <i class="bx bx-confused h2 text-warning mb-0"></i>
                  </div>
                  <div class="media-body">
                    <p class="text-muted mb-2">Tolerated</p>
                    <h5 class="mb-0">
                      {{ tolerated }}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="media">
                  <div class="me-3 align-self-center">
                    <i class="bx bx-angry h2 text-danger mb-0"></i>
                  </div>
                  <div class="media-body">
                    <p class="text-muted mb-2">Frustrated</p>
                    <h5 class="mb-0">
                      {{ frustrated }}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="card mini-stats-wid">
              <div class="card-body">
                <div class="media">
                  <div class="me-3 align-self-center">
                    <i class="bx bx-server h2 text-info mb-0"></i>
                  </div>
                  <div class="media-body">
                    <p class="text-muted mb-2">Score</p>
                    <h5 class="mb-0">
                      {{ score.toFixed(2) }}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
            <div class="card">
              <div class="card-body">
                <div class="d-flex flex-wrap">
                  <h4 class="card-title mb-3">Response Time <small>in milliseconds</small></h4>
                  <div class="ms-auto">
                    <div class="toolbar button-items text-end">
                      <button v-for="parameter in state.metrics_url_parameters" v-bind:key="parameter.key"
                              type="button"
                              class="btn btn-light btn-sm"
                              v-on:click="retrieveMonitorMetrics(state.monitor, parameter.value)">
                        {{ parameter.key }}
                      </button>
                    </div>
                  </div>
                </div>
                <div>
                  <div id="overview-chart" class="apex-charts" dir="ltr"></div>
                  <apexchart class="apex-charts" height="240" dir="ltr" :series="series" :options="apex"></apexchart>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>